
export const translation_dic = {
  en: {
    translation: {
      logo: "logo",
      demo: "This demo app was internationalized by i18next",
      "Cohort Analysis": "Cohort Analysis",
      "Case Analysis": "Case Analysis",
      now: "Current date and time are {{currentDateTime, datetime}}",
      "table_pagination_range": "Page {{page}} , Displaying rows {{from}}-{{to}} of total {{count}}"
    },
  },

};



export async function loadExtraTranslations(langsToLoad = ["it", "de", "es", "ca", "fr"]) {
  const base = `${window.config.static_files}/translations/`;

  const output = {};

  for (const lng of langsToLoad) {
    try {
      const res = await fetch(`${base}${lng}.json`);
      
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      
      const json = await res.json();
      output[lng] = { translation: json };
    } catch (err) {
      console.error(`Error loading ${lng}.json:`, err);
    }
  }

  if (langsToLoad.length === 1) {
    return output[langsToLoad[0]];
  }

  return output;
}

